import { Button, Grid, Paper, Typography } from '@mui/material';
import { DataGrid, GridColDef, gridClasses } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import WidgetLoading from '../../Shared/WidgetLoading';
import b64toBlob from 'b64-to-blob';
import { fetchOnboardingPerformance, exportOnboardingPerformance } from '../../../Widgets/WidgetService';

const OnboardingPerformance = () => {
    const [populationGoals, setPopulationGoals] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [downLoading, setDownLoading] = useState<boolean>(false);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(15);

    const getPopulationGoals = async () => {
        setIsLoading(true);
        const response = await fetchOnboardingPerformance();
        setPopulationGoals(response);
        setIsLoading(false);
    };

    const columns: GridColDef[] = [
        {
            field: 'PopulationName',
            headerName: 'Population',
            flex: 1,
        },
        {
            field: 'PercentToGoal',
            headerName: 'Current / Goal (Percent to Goal)',
            flex: 1,
            valueGetter: (value, row) => `${row.PercentToGoal}%`,
        },
        {
            field: 'MembersScheduled',
            headerName: 'Members Scheduled',
            flex: 1,
        },
        {
            field: 'NumberServiceRefusals',
            headerName: '# of Service Refusals',
            flex: 1,
        },
        {
            field: 'UndeterminedMembers',
            headerName: 'Undetermined Members',
            flex: 1,
        },
    ];

    useEffect(() => {
        getPopulationGoals();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const exportOnboardingPerformances = async () => {
        setDownLoading(true);
        const response = await exportOnboardingPerformance();
        let blob = b64toBlob(response.base64String, 'text/csv');
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = url;
        var date = new Date();
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();
        var dateInfo = [(mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd, date.getFullYear()].join('');
        link.setAttribute('download', `OnboardingPerformance - ${dateInfo}.xlsx`);
        link.click();
        link.remove();
        setDownLoading(false);
    };

    return (
        <Grid size={{ xs: 12, lg: 6 }} position="relative">
            {isLoading && <WidgetLoading />}
            <Paper className="smartdashboard-widget" elevation={5} sx={{ height: 'calc(100vh - 140px)', maxHeight: '650px', display: 'flex', flexDirection: 'column', overflow: 'auto' }}>
                <Grid container spacing={2} paddingLeft={2} paddingRight={2}>
                    <Grid size={12} textAlign="center">
                        <Typography color={'primary'} variant="h6" textAlign={'center'}>
                            Onboarding Performance
                        </Typography>
                    </Grid>
                    <Grid size={10}></Grid>
                    <Grid size={2} display={'flex'} maxHeight="55px">
                        <Button
                            style={{ minWidth: '120px', marginLeft: 'auto' }}
                            onClick={() => exportOnboardingPerformances()}
                            variant="contained"
                            color="success"
                            disabled={downLoading || populationGoals?.length === 0}
                        >
                            {downLoading ? 'Exporting..' : 'Export'}
                        </Button>
                    </Grid>
                    <Grid size={12} marginTop={1}>
                        <div style={{ width: '100%', height: 'calc(100vh - 285px)', maxHeight: '500px' }}>
                            <DataGrid
                                rows={populationGoals}
                                columns={columns}
                                paginationModel={{ pageSize: pageSize, page: page }}
                                pageSizeOptions={[5]}
                                onPaginationModelChange={(model) => {
                                    setPageSize(model.pageSize);
                                    setPage(model.page);
                                }}
                                getRowId={(row) => Math.random()}
                                getRowHeight={() => 'auto'}
                                sx={{
                                    [`& .${gridClasses.cell}`]: {
                                        py: 1,
                                    },
                                }}
                            />
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    );
};

export default OnboardingPerformance;
